<template>
    <div id="register-member-second">
        <div id="header">
            <img class="back" src="../../assets/common_back.png" alt=""
                 @click="registerHaveAccountNumber">
            <span class="title">注册</span>
        </div>

        <div id="body-bg">
            <div id="body">
                <div style="height: 10px; width: 100%"></div>
                <div id="line">
                    <div id="body-header">
                        <div class="header-icon"> > </div>
                        <span style="color: #ed3f14; margin: 5px">会员注册</span>
                    </div>

                    <div id="body-form">

                        <div class="info">
                            <img class="icon"
                                 src="../../assets/password.png" alt="">
                            <input class="input" type="password" name="memberNumber"
                                   placeholder="密码"
                                   v-model="registerForm.password">
                        </div>

                        <div class="info">
                            <img class="icon"
                                 src="../../assets/password.png" alt="">
                            <input class="input" type="password" name="memberNumber"
                                   placeholder="重复密码"
                                   v-model="registerForm.confirmPassword">
                        </div>

                        <div class="info">
                            <img class="icon"
                                 src="../../assets/member.png" alt="">
                            <input class="input" type="text" name="memberNumber"
                                   placeholder="真实姓名"
                                   v-model="registerForm.realName" @input="inputChange">
                        </div>
                        <div class="tip">必须为纯中文</div>

                        <div class="info">
                            <img class="icon"
                                 src="../../assets/member_phone.png" alt="">
                            <input class="input" type="tel" name="memberNumber"
                                   placeholder="手机"
                                   v-model="registerForm.mobile"  maxlength="11">
                        </div>

                        <div class="info">
                            <img class="icon"
                                 src="../../assets/member_phone.png" alt="">
                            <input class="input" type="text" name="verifyCode"
                                   placeholder="验证码"
                                   v-model="registerForm.verifyCode" :maxlength="4">
                            <button v-if="isCaptcha" class="send-captcha-btn" @click="sendCaptcha">
                                发送
                            </button>
                            <button v-if="!isCaptcha" class="send-captcha-btn rest" >
                                {{ count }}s
                            </button>
                        </div>
                    </div>

                    <div id="submit">
                        <button class="submit-btn" @click="registerSubmit" :disabled="btnDisable">提交注册</button>
                    </div>

                    <div id="have-account-number">
                            <span class="btn"
                                  @click="registerHaveAccountNumber">已有账号</span>
                    </div>
                </div>
                <div style="height: 10px; width: 100%"></div>
            </div>


            <base-dialog v-show="messageVisible" :title="title" width="80%" @close="close">
                <p>{{ message }}</p>
            </base-dialog>

            <div class="toast" v-show="toastShow">
                {{toastText}}
            </div>
        </div>

        <div style="height: 10px"></div>
    </div>
</template>

<script>
    import BaseDialog from "../../components/BaseDialog";
    import { SendCaptcha } from "../../api/Login";

    export default {
        name: "MemberRegisterSecond",
        components: {BaseDialog},
        data() {
            return {
                registerForm: {
                    // username: '',
                    password: '',
                    confirmPassword: '',
                    realName: '',
                    mobile: '',
                    verifyCode: '',
                },
                display: false,
                drawerWidth: '200px',

                toastShow: false,
                toastText: '',

                title: '提示',
                messageVisible: false,
                message: "",

                isSuccess: false,

                btnDisable: false,
                isCaptcha: true,
                timer: null,
                count: '', //发送验证码倒计时
            }
        },

        methods: {
            close() {
                this.messageVisible = false;
                this.$emit('close');
                if (this.isSuccess) {
                    this.$router.push({path: '/'});
                }
            },

            toast (e) {
                let _that = this;
                this.toastText = e;
                this.toastShow = true;
                setTimeout(function(){
                    _that.toastShow = false;
                }, 1500)
            },

            //获取验证码
            sendCaptcha() {
                let telReg = /^1[3456789]\d{9}$/;
                if (!telReg.test(this.registerForm.mobile)) {
                    this.toast("请输入正确的电话号码");
                    return;
                }
                
                if (this.isCaptcha) {
                    this.btnDisable = true;
                    SendCaptcha(this.registerForm.mobile).then((response) => {
                        if (this.$API_CODE.OK === response.code) {
                            this.toast("验证码已发送");

                            const TIME_COUNT = 60;
                            if (!this.timer) {
                                this.count = TIME_COUNT;
                                this.isCaptcha = false;
                                this.timer = setInterval(() => {
                                    if (this.count > 0 && this.count <= TIME_COUNT) {
                                        this.count--;
                                    } else {
                                        this.isCaptcha = true;
                                        clearInterval(this.timer);
                                        this.timer = null;
                                    }
                                }, 1000);
                            }
                        } else {
                            this.messageVisible = true;
                            this.message = response.message;
                        }
                        this.btnDisable = false;
                    });
                }
            },

            //提交注册
            registerSubmit() {

                if (this.registerForm.password.trim().length < 6) {
                    this.toast('密码长度必须6～20位');
                    return;
                }

                if (this.registerForm.password === '') {
                    this.toast("请输入密码");
                    return;
                }

                if (this.registerForm.password !== this.registerForm.confirmPassword) {
                    this.toast("请确认密码是否正确");
                    return;
                }

                if (this.registerForm.realName === '') {
                    this.toast("请输入真实姓名");
                    return;
                }

                if (this.registerForm.realName.trim().length > 50) {
                    this.toast("真实姓名长度不能超过50个汉字");
                    return;
                }

                let telReg = /^1[3456789]\d{9}$/;
                if (!telReg.test(this.registerForm.mobile)) {
                    this.toast("请输入正确的电话号码");
                    return;
                }
                
                if (!this.registerForm.verifyCode) {
                    this.toast("请输入验证码");
                    return;
                }
                
                this.btnDisable = true;
                this.$store.dispatch('Registry', this.registerForm)
                    .then((response) => {
                    if (response.code === this.$API_CODE.OK) {
                        this.isSuccess = true;
                        this.message = '会员注册成功，会员名：' + response.data.username;
                        this.messageVisible = true;
                        this.btnDisable = false;

                    }
                }).catch(error=>{
                    this.message = error.message;
                    this.messageVisible = true;
                    this.btnDisable = false;
                })
            },

            //已有账号和返回
            registerHaveAccountNumber() {
                this.$router.push({path: '/'});
            },

            //限制输入框的内容只能为汉字
            inputChange(e) {
                const o = e.target;
                this.registerForm.realName = o.value.replace(/[^\u4E00-\u9FA5]/g, '');

            },

        }
    }
</script>

<style scoped lang="scss">

    #register-member-second {
        background-color: #f2f2f2;
        position: absolute;
        width: 100%;
        height: 100%;
        //header区域
        #header {
            height: 40px;
            line-height: 40px;
            background-color: #ed3f14;
            font-size: 1rem;

            .back {
                margin-top: 8px;
                line-height: 35px;
                margin-left: 10px;
                float: left;
            }

            .more {
                margin-top: 8px;
                line-height: 35px;
                margin-right: 10px;
                float: right;
            }

            .title {
                color: white;
            }
        }

        //body区域
        #body {
            margin: 30px;
            border-radius: 15px;
            background-color: white;
            clear: both;

            //表单外面的红线
            #line {
                border: 1px solid #ed3f14;
                margin: 10px;
                border-radius: 10px;

                //会员注册表单title
                #body-header {
                    margin-left: 10px;
                    margin-top: 20px;
                    margin-bottom: 20px;
                    position: relative;
                    float: left;
                    font-size: 1rem;

                    .header-icon {
                        background: #ed3f14;
                        width: 20px;
                        height: 20px;
                        text-align: center;
                        line-height: 20px;
                        color: #FFFFFF;
                        font-weight: bold;
                        border-radius: 90px;
                        float: left;
                    }
                }

                //表单
                #body-form {
                    clear: both;
                    margin-left: 15px;
                    margin-right: 15px;
                    margin-top: 30px;

                    .info {
                        width: auto;
                        height: 45px;
                        border-radius: 5px;
                        border: 2px solid #ed3f14;
                        display: flex;
                        align-items: center;
                        margin-top: 20px;

                    }

                    .icon {
                        width: 16px;
                        height: 16px;
                        float: left;
                        margin-left: 10px;
                    }

                    .input {
                        height: 40px;
                        border: 0;
                        outline: none;
                        margin-left: 10px;
                        font-size: 0.8rem;
                        width: 100%;
                    }

                    .input::-webkit-input-placeholder { /* WebKit browsers */

                        color: #ed3f14;

                    }

                    .tip {
                        color: #757575;
                        font-size: 0.8rem;
                        text-align: left;
                        margin: 3px;
                    }
                }

                #submit {
                        margin-left: 15px;
                        margin-right: 15px;

                        .submit-btn {
                            width: 100%;
                            /*height: 40px;*/
                            margin-top: 20px;
                            margin-bottom: 10px;
                            border: 0;
                            line-height: 35px;
                            border-radius: 5px;
                            background-color: #ed3f14;
                            color: white;
                            font-size: 1rem;
                        }
                    }

                    .send-captcha-btn {
                        float: right;
                        width: 30%;
                        height: 30px;
                        margin-right: 5px;
                        background-color: #ed3f14;
                        color: white;
                        line-height: 20px;
                        border-radius: 5px;
                        font-size: 0.9rem;
                        border: 0;
                    }

                    .verify-btn {
                        width: 100%;
                        height: 40px;
                        margin-top: 20px;
                        background-color: #ed3f14;
                        color: white;
                        line-height: 30px;
                        border-radius: 5px;
                        font-size: 1rem;
                        border: 0;
                    }

                    .rest {
                        background-color: #757575;
                    }

                    #have-account-number {
                        margin-bottom: 20px;

                        .btn {
                            height: 30px;
                            color: #ed3f14;
                            background: white;
                            margin-bottom: 20px;
                            font-size: 1rem;
                            border-left: 0;
                            border-right: 0;
                            border-top: 0;
                            border-bottom-style: solid;
                            border-bottom-color: #ed3f14;
                        }
                    }
            }
        }
    }

</style>